<script setup>
import { useCurrency } from '@/composables/useCurrency.js'

const props = defineProps({
  alerts: { type: Array, default: () => [] },
})

const { formatDateTime } = useCurrency()

const eventBadge = {
  geofenceEnter:  { label: 'Geofence Enter', style: { background: 'color-mix(in oklab, var(--info, var(--accent)) 14%, transparent)', color: 'var(--info, var(--accent))' } },
  geofenceExit:   { label: 'Geofence Exit',  style: { background: 'color-mix(in oklab, var(--warn) 18%, transparent)', color: 'var(--warn)' } },
  overspeed:      { label: 'Overspeed',      style: { background: 'var(--dangerSoft)', color: 'var(--danger)' } },
  deviceMoving:   { label: 'Moving',         style: { background: 'var(--okSoft)', color: 'var(--ok)' } },
  deviceStopped:  { label: 'Stopped',        style: { background: 'var(--surfaceAlt)', color: 'var(--inkSoft)' } },
  ignitionOn:     { label: 'Ignition On',    style: { background: 'var(--okSoft)', color: 'var(--ok)' } },
  ignitionOff:    { label: 'Ignition Off',   style: { background: 'var(--surfaceAlt)', color: 'var(--inkSoft)' } },
  alarm:          { label: 'Alarm',          style: { background: 'var(--dangerSoft)', color: 'var(--danger)' } },
}

function badge(eventType) {
  return eventBadge[eventType] || { label: eventType, style: { background: 'var(--surfaceAlt)', color: 'var(--inkSoft)' } }
}
</script>

<template>
  <div class="bg-[color:var(--surface)] rounded-[var(--radius-lg)] border border-[color:var(--line)] overflow-hidden">
    <div class="px-4 py-3 border-b border-[color:var(--line)]">
      <h3 class="text-sm font-semibold text-[color:var(--inkSoft)]">Alert History</h3>
    </div>
    <div v-if="alerts.length === 0" class="px-4 py-8 text-center text-sm text-[color:var(--muted)]">
      No alerts recorded.
    </div>
    <div v-else class="overflow-x-auto">
      <table class="min-w-full divide-y divide-[color:var(--line)] text-sm">
        <thead :style="{ background: 'var(--surfaceAlt)' }">
          <tr>
            <th class="px-4 py-2 text-left text-xs font-medium text-[color:var(--muted)] uppercase tracking-wider">Time</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-[color:var(--muted)] uppercase tracking-wider">Event</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-[color:var(--muted)] uppercase tracking-wider">Speed</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-[color:var(--line)]">
          <tr v-for="alert in alerts" :key="alert.id" class="hover:bg-[color:var(--surfaceAlt)]">
            <td class="px-4 py-2 whitespace-nowrap text-[color:var(--muted)] font-mono text-xs">
              {{ formatDateTime(alert.occurred_at) }}
            </td>
            <td class="px-4 py-2 whitespace-nowrap">
              <span class="px-2 py-0.5 rounded-full text-xs font-medium" :style="badge(alert.event_type).style">
                {{ badge(alert.event_type).label }}
              </span>
            </td>
            <td class="px-4 py-2 whitespace-nowrap text-[color:var(--inkSoft)]">
              {{ alert.payload?.speed != null ? `${Math.round(alert.payload.speed)} km/h` : '—' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
